(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  var DATA_DEPTH_ATTR = 'data-navmenu-depth';
  var SUBMENU_SELECTOR = '[data-navmenu-submenu]';
  var TRIGGER_SELECTOR = '[data-navmenu-trigger]';
  var PARENT_SELECTOR = '[data-navmenu-parent]';
  var LINK_PARENT_SELECTOR = '.navmenu-link-parent';
  var OPEN_TRANSITION_DURATION = 350;
  var CLOSE_TRANSITION_DURATION = 250;
  var ANIMATION_FALLBACK_BUFFER = 75;
  var ITEM_STAGGER_INTERVAL = 55;
  var ITEM_STAGGER_EXIT_MULTIPLIER = 0.6;
  var ITEM_ANIMATION_BUFFER = 120;

  function toInteger(value) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  function getDepthFromListItem(listItem) {
    if (!listItem || typeof listItem.closest !== 'function') {
      return null;
    }

    var parentList = listItem.closest('[' + DATA_DEPTH_ATTR + ']');
    if (!parentList) {
      return null;
    }

    return toInteger(parentList.getAttribute(DATA_DEPTH_ATTR));
  }

  function isPrimaryClick(event) {
    if (!event) {
      return false;
    }

    if (event.defaultPrevented) {
      return false;
    }

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return false;
    }

    if (typeof event.button === 'number' && event.button !== 0) {
      return false;
    }

    return true;
  }

  function toggleBodySubdrawerClass(isOpen) {
    if (typeof document === 'undefined') {
      return;
    }

    var body = document.body;
    if (!body || !body.classList) {
      return;
    }

    if (isOpen) {
      body.classList.add('mobile-subdrawer-open');
    } else {
      body.classList.remove('mobile-subdrawer-open');
    }
  }

  function dispatchClick(element) {
    if (!element || typeof element.dispatchEvent !== 'function') {
      return;
    }

    var event;

    if (typeof window.Event === 'function') {
      event = new window.Event('click', { bubbles: true, cancelable: true });
    } else {
      event = document.createEvent('Event');
      event.initEvent('click', true, true);
    }

    try {
      element.dispatchEvent(event);
    } catch (error) {
      // Silently ignore; best-effort reset
    }
  }

  function initAllDrawers(root) {
    var scope = root || document;
    var navs = Array.prototype.slice.call(scope.querySelectorAll('[data-mobile-nav]'));

    navs.forEach(function (nav) {
      if (nav.__mobileSubDrawerInstance) {
        return;
      }

      var instance = new MobileNavSubDrawer(nav);
      instance.init();
      nav.__mobileSubDrawerInstance = instance;
    });
  }

  function destroyInScope(root) {
    if (!root) {
      return;
    }

    var navs = Array.prototype.slice.call(root.querySelectorAll('[data-mobile-nav]'));
    navs.forEach(function (nav) {
      if (nav.__mobileSubDrawerInstance) {
        nav.__mobileSubDrawerInstance.destroy();
        delete nav.__mobileSubDrawerInstance;
      }
    });
  }

  function MobileNavSubDrawer(root) {
    this.root = root;
    this.panel = root.querySelector('[data-mobile-nav-panel]');
    this.navContent = root.querySelector('[data-mobile-nav-content]');
    this.featured = root.querySelector('[data-mobile-nav-featured]');
    this.subDrawer = root.querySelector('[data-mobile-subdrawer]');
    this.subDrawerContent = this.subDrawer ? this.subDrawer.querySelector('[data-mobile-subdrawer-content]') : null;
    this.subDrawerTitle = this.subDrawer ? this.subDrawer.querySelector('[data-mobile-subdrawer-title]') : null;
    this.backButton = this.subDrawer ? this.subDrawer.querySelector('[data-mobile-subdrawer-back]') : null;
    this.defaultTitle = this.subDrawer ? this.subDrawer.getAttribute('data-mobile-subdrawer-default-title') || '' : '';
    this.subDrawerCtaWrapper = this.subDrawer ? this.subDrawer.querySelector('[data-mobile-subdrawer-cta]') : null;
    this.subDrawerCtaLink = this.subDrawerCtaWrapper ? this.subDrawerCtaWrapper.querySelector('[data-mobile-subdrawer-cta-link]') : null;
    this.subDrawerCtaTemplate = this.subDrawerCtaWrapper ? this.subDrawerCtaWrapper.getAttribute('data-mobile-subdrawer-cta-template') || '' : '';
    this.subDrawerCtaBaseText = this.subDrawerCtaLink ? this.subDrawerCtaLink.textContent.trim() : '';

    this.active = null;
    this.panelScrollTop = 0;
    this.cleanups = [];
    this.animationFallbackTimer = null;
    this.pendingRootReset = false;
    this.pendingRootClassRemoval = false;
    this.itemAnimationTimer = null;
    this.prefersReducedMotion = false;
    this.motionMediaQuery = null;

    this.boundRootClick = this.onRootClick.bind(this);
    this.boundKeydown = this.onKeydown.bind(this);
    this.boundBackClick = this.onBackClick.bind(this);
    this.boundNavClose = this.onNavClose.bind(this);
    this.boundHandleMutations = this.handleMutations.bind(this);
    this.boundTransitionEnd = this.onTransitionEnd.bind(this);
    this.boundMotionPreferenceChange = this.onMotionPreferenceChange.bind(this);
  }

  MobileNavSubDrawer.prototype.init = function () {
    if (!this.subDrawer || !this.subDrawerContent) {
      return;
    }

    this.setupMotionPreference();

    if (this.root && this.root.classList) {
      this.root.classList.add('mobile-nav--subdrawer-enabled');
    }

    this.subDrawer.classList.remove('mobile-subdrawer--active');
    this.subDrawer.setAttribute('data-animation-state', this.subDrawer.getAttribute('data-animation-state') || 'closed');

    this.subDrawer.addEventListener('transitionend', this.boundTransitionEnd);
    this.cleanups.push(this.removeListener.bind(this, this.subDrawer, 'transitionend', this.boundTransitionEnd));

    if (this.panel) {
      this.panel.addEventListener('click', this.boundRootClick);
      this.cleanups.push(this.removeListener.bind(this, this.panel, 'click', this.boundRootClick));
    }

    this.root.addEventListener('keydown', this.boundKeydown);
    this.cleanups.push(this.removeListener.bind(this, this.root, 'keydown', this.boundKeydown));

    if (this.backButton) {
      this.backButton.addEventListener('click', this.boundBackClick);
      this.cleanups.push(this.removeListener.bind(this, this.backButton, 'click', this.boundBackClick));
    }

    var closeEls = Array.prototype.slice.call(this.root.querySelectorAll('[data-mobile-nav-close]'));
    closeEls.forEach(function (el) {
      el.addEventListener('click', this.boundNavClose);
      this.cleanups.push(this.removeListener.bind(this, el, 'click', this.boundNavClose));
    }, this);

    var overlay = this.root.querySelector('[data-mobile-nav-overlay]');
    if (overlay) {
      overlay.addEventListener('click', this.boundNavClose);
      this.cleanups.push(this.removeListener.bind(this, overlay, 'click', this.boundNavClose));
    }

    if (window.MutationObserver) {
      this.observer = new MutationObserver(this.boundHandleMutations);
      this.observer.observe(this.root, { attributes: true, attributeFilter: ['data-open', 'aria-hidden'] });
      this.cleanups.push(function () {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }.bind(this));
    }
  };

  MobileNavSubDrawer.prototype.removeListener = function (element, eventName, handler, options) {
    if (element && element.removeEventListener) {
      element.removeEventListener(eventName, handler, options || false);
    }
  };

  MobileNavSubDrawer.prototype.forceLayout = function (element) {
    if (!element || typeof element.getBoundingClientRect !== 'function') {
      return;
    }

    try {
      element.getBoundingClientRect();
    } catch (error) {
      // noop
    }
  };

  MobileNavSubDrawer.prototype.setupMotionPreference = function () {
    if (this.motionMediaQuery || typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      this.prefersReducedMotion = this.motionMediaQuery ? !!this.motionMediaQuery.matches : false;
      return;
    }

    var mediaQuery;
    try {
      mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    } catch (error) {
      this.prefersReducedMotion = false;
      return;
    }

    this.motionMediaQuery = mediaQuery;
    this.prefersReducedMotion = !!mediaQuery.matches;

    var handler = this.boundMotionPreferenceChange;
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handler);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(handler);
    }

    this.cleanups.push(function () {
      if (!this.motionMediaQuery) {
        return;
      }

      if (typeof this.motionMediaQuery.removeEventListener === 'function') {
        this.motionMediaQuery.removeEventListener('change', handler);
      } else if (typeof this.motionMediaQuery.removeListener === 'function') {
        this.motionMediaQuery.removeListener(handler);
      }

      this.motionMediaQuery = null;
    }.bind(this));
  };

  MobileNavSubDrawer.prototype.onMotionPreferenceChange = function (event) {
    this.prefersReducedMotion = !!(event && event.matches);

    if (this.active && this.active.submenu) {
      this.prepareSubmenuItems(this.active.submenu);
    }
  };

  MobileNavSubDrawer.prototype.clearItemAnimationTimer = function () {
    if (!this.itemAnimationTimer) {
      return;
    }

    if (typeof window !== 'undefined' && typeof window.clearTimeout === 'function') {
      window.clearTimeout(this.itemAnimationTimer);
    } else {
      clearTimeout(this.itemAnimationTimer);
    }

    this.itemAnimationTimer = null;
  };

  MobileNavSubDrawer.prototype.getItemAnimationDuration = function (direction, itemCount) {
    var count = typeof itemCount === 'number' ? itemCount : (this.active && this.active.itemCount) || 0;
    if (count < 0) {
      count = 0;
    }

    var baseDuration = direction === 'exit' ? CLOSE_TRANSITION_DURATION : OPEN_TRANSITION_DURATION;
    var interval = direction === 'exit' ? ITEM_STAGGER_INTERVAL * ITEM_STAGGER_EXIT_MULTIPLIER : ITEM_STAGGER_INTERVAL;
    var totalDelay = count > 1 ? (count - 1) * interval : 0;

    return baseDuration + totalDelay + ITEM_ANIMATION_BUFFER;
  };

  MobileNavSubDrawer.prototype.prepareSubmenuItems = function (submenu) {
    if (!submenu || typeof submenu.querySelectorAll !== 'function') {
      return 0;
    }

    var items = submenu.querySelectorAll(':scope > li');
    var count = 0;

    Array.prototype.forEach.call(items, function (item, index) {
      count += 1;
      item.setAttribute('data-mobile-subdrawer-prepared', 'true');

      if (this.prefersReducedMotion) {
        item.style.removeProperty('--subdrawer-stagger-index');
      } else {
        item.style.setProperty('--subdrawer-stagger-index', index);
      }
    }, this);

    submenu.setAttribute('data-mobile-subdrawer-item-count', String(count));
    return count;
  };

  MobileNavSubDrawer.prototype.resetPreparedItems = function (submenu) {
    if (!submenu || typeof submenu.querySelectorAll !== 'function') {
      return;
    }

    var items = submenu.querySelectorAll('[data-mobile-subdrawer-prepared]');
    Array.prototype.forEach.call(items, function (item) {
      item.removeAttribute('data-mobile-subdrawer-prepared');
      item.style.removeProperty('--subdrawer-stagger-index');
    });

    submenu.removeAttribute('data-mobile-subdrawer-item-count');
  };

  MobileNavSubDrawer.prototype.animateSubmenuItems = function (direction, callback) {
    if (!this.subDrawer || !this.active || !this.active.submenu) {
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }

    this.clearItemAnimationTimer();

    var enterClass = 'mobile-subdrawer--items-enter';
    var exitClass = 'mobile-subdrawer--items-exit';
    this.subDrawer.classList.remove(enterClass, exitClass);

    if (direction === 'enter') {
      this.subDrawer.classList.add('mobile-subdrawer--items-active');
    }

    if (this.prefersReducedMotion) {
      if (direction === 'exit') {
        this.subDrawer.classList.remove('mobile-subdrawer--items-active');
      }

      if (typeof callback === 'function') {
        callback();
      }

      return;
    }

    this.forceLayout(this.subDrawer);

    var targetClass = direction === 'exit' ? exitClass : enterClass;
    this.subDrawer.classList.add(targetClass);

    var duration = this.getItemAnimationDuration(direction, this.active.itemCount);

    this.itemAnimationTimer = window.setTimeout(function () {
      this.subDrawer.classList.remove(targetClass);

      if (direction === 'exit') {
        this.subDrawer.classList.remove('mobile-subdrawer--items-active');
      }

      this.clearItemAnimationTimer();

      if (typeof callback === 'function') {
        callback();
      }
    }.bind(this), duration);
  };

  MobileNavSubDrawer.prototype.triggerAnimation = function () {
    if (!this.subDrawer) {
      return;
    }

    var self = this;

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        if (!self.subDrawer) {
          return;
        }

        self.subDrawer.setAttribute('data-animation-state', 'closed');
        self.forceLayout(self.subDrawer);

        window.requestAnimationFrame(function () {
          if (!self.subDrawer) {
            return;
          }

          self.subDrawer.setAttribute('data-animation-state', 'open');
        });
      });
    } else {
      this.subDrawer.setAttribute('data-animation-state', 'closed');
      this.forceLayout(this.subDrawer);

      var self = this;
      setTimeout(function () {
        if (self.subDrawer) {
          self.subDrawer.setAttribute('data-animation-state', 'open');
        }
      }, 16);
    }
  };

  MobileNavSubDrawer.prototype.hideRootContent = function () {
    if (this.navContent) {
      this.navContent.setAttribute('aria-hidden', 'true');
      this.navContent.classList.add('mobile-nav-content--hidden');
    }

    if (this.featured) {
      this.featured.setAttribute('aria-hidden', 'true');
      this.featured.classList.add('mobile-nav-featured--hidden');
    }
  };

  MobileNavSubDrawer.prototype.restoreRootContent = function () {
    if (this.navContent) {
      this.navContent.removeAttribute('aria-hidden');
      this.navContent.classList.remove('mobile-nav-content--hidden');
    }

    if (this.featured) {
      this.featured.removeAttribute('aria-hidden');
      this.featured.classList.remove('mobile-nav-featured--hidden');
    }
  };

  MobileNavSubDrawer.prototype.onRootClick = function (event) {
    if (!event || !event.target) {
      return;
    }

    var handled = false;

    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (trigger && this.root.contains(trigger)) {
      handled = this.handleTriggerClick(event, trigger);
    }

    if (!handled) {
      var link = event.target.closest(LINK_PARENT_SELECTOR);
      if (link && this.root.contains(link)) {
        handled = this.handleParentLinkClick(event, link);
      }
    }

    if (handled) {
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      } else {
        event.stopPropagation();
      }
    }
  };

  MobileNavSubDrawer.prototype.handleTriggerClick = function (event, trigger) {
    var listItem = trigger.closest(PARENT_SELECTOR);
    if (!listItem) {
      return false;
    }

    var depth = getDepthFromListItem(listItem);
    if (depth !== 1) {
      return false;
    }

    event.preventDefault();
    event.stopPropagation();

    this.openSubDrawer(listItem, trigger);
    return true;
  };

  MobileNavSubDrawer.prototype.handleParentLinkClick = function (event, link) {
    var listItem = link.closest(PARENT_SELECTOR);
    if (!listItem) {
      return false;
    }

    var depth = getDepthFromListItem(listItem);
    if (depth !== 1) {
      return false;
    }

    if (!isPrimaryClick(event)) {
      return false;
    }

    event.preventDefault();
    event.stopPropagation();
    this.openSubDrawer(listItem, link);
    return true;
  };

  MobileNavSubDrawer.prototype.onBackClick = function (event) {
    if (event) {
      event.preventDefault();
    }

    if (!this.active) {
      return;
    }

    this.closeSubDrawer({ returnFocus: this.active.toggleButton });
  };

  MobileNavSubDrawer.prototype.onKeydown = function (event) {
    if (!this.active) {
      return;
    }

    if (event.key === 'Escape' || event.key === 'Esc') {
      event.stopPropagation();
      this.closeSubDrawer({ returnFocus: this.active.toggleButton });
    }
  };

  MobileNavSubDrawer.prototype.onNavClose = function () {
  this.closeSubDrawer({ skipFocus: true, forceInstant: true });
  };

  MobileNavSubDrawer.prototype.handleMutations = function (mutations) {
    var navOpen = this.isNavCurrentlyOpen();
    if (navOpen || !this.active) {
      return;
    }

    this.closeSubDrawer({ skipFocus: true });
  };

  MobileNavSubDrawer.prototype.isNavCurrentlyOpen = function () {
    if (!this.root) {
      return false;
    }

    if (this.root.hasAttribute('data-open')) {
      return this.root.getAttribute('data-open') === 'true';
    }

    if (this.root.hasAttribute('aria-hidden')) {
      return this.root.getAttribute('aria-hidden') !== 'true';
    }

    return true;
  };

  MobileNavSubDrawer.prototype.openSubDrawer = function (listItem, trigger) {
    if (!listItem || !this.subDrawer || !this.subDrawerContent) {
      return;
    }

    var submenu = listItem.querySelector(':scope > ' + SUBMENU_SELECTOR);
    if (!submenu) {
      submenu = listItem.querySelector(SUBMENU_SELECTOR);
    }

    if (!submenu) {
      if (this.active && this.active.listItem === listItem) {
        this.closeSubDrawer({ returnFocus: trigger });
      }
      return;
    }

    if (this.active && this.active.submenu === submenu) {
      this.closeSubDrawer({ returnFocus: trigger });
      return;
    }

    this.closeSubDrawer({ skipFocus: true });

    this.panelScrollTop = this.panel ? this.panel.scrollTop : 0;

    var placeholder = document.createElement('div');
    placeholder.setAttribute('data-mobile-subdrawer-placeholder', 'true');
    submenu.parentNode.insertBefore(placeholder, submenu);

    this.subDrawerContent.innerHTML = '';
    this.subDrawerContent.appendChild(submenu);

    var inlineStyle = submenu.getAttribute('style');
    if (inlineStyle) {
      submenu.setAttribute('data-mobile-subdrawer-inline-style', inlineStyle);
      submenu.removeAttribute('style');
    } else {
      submenu.removeAttribute('data-mobile-subdrawer-inline-style');
    }

    var previousState = submenu.getAttribute('data-animation-state');
    submenu.setAttribute('data-mobile-subdrawer-prev-state', previousState === null ? '' : previousState);
    submenu.setAttribute('data-animation-state', 'open');

    var previousAnimation = submenu.getAttribute('data-animation');
    submenu.setAttribute('data-mobile-subdrawer-prev-animation', previousAnimation === null ? '' : previousAnimation);
    submenu.removeAttribute('data-animation');

    var wasHidden = submenu.hasAttribute('hidden');
    submenu.setAttribute('data-mobile-subdrawer-was-hidden', wasHidden ? 'true' : 'false');
    if (wasHidden) {
      submenu.removeAttribute('hidden');
    }

    var link = listItem.querySelector(':scope > ' + LINK_PARENT_SELECTOR);
    if (link) {
      link.setAttribute('aria-expanded', 'true');
      link.classList.add('navmenu-link-parent-active');
      link.setAttribute('data-mobile-subdrawer-applied', 'true');
    }

    var toggleButton = listItem.querySelector(':scope > ' + TRIGGER_SELECTOR);
    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'true');
    }

    this.updateTitle(link);
    this.setRootState(true);

    submenu.classList.add('mobile-subdrawer__list');
    this.subDrawerContent.scrollTop = 0;

    this.active = {
      submenu: submenu,
      placeholder: placeholder,
      listItem: listItem,
      trigger: trigger,
      toggleButton: toggleButton,
      link: link
    };

    this.clearItemAnimationTimer();
    var itemCount = this.prepareSubmenuItems(submenu);
    this.active.itemCount = itemCount;
    this.animateSubmenuItems('enter');

    this.updateCta(link);

    if (this.backButton) {
      var focusBackButton = function () {
        try {
          this.backButton.focus();
        } catch (error) {
          // focus fallback not critical
        }
      }.bind(this);

      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(focusBackButton);
      } else {
        focusBackButton();
      }
    }
  };

  MobileNavSubDrawer.prototype.closeSubDrawer = function (options) {
    options = options || {};

    if (!this.active) {
      this.setRootState(false);
      return;
    }

  var forceInstant = options.forceInstant === true;
  var context = this.active;
  var submenu = context.submenu;
  var placeholder = context.placeholder;
  var toggleButton = context.toggleButton;
  var link = context.link;
  var trigger = context.trigger;

    if (link) {
      link.setAttribute('aria-expanded', 'false');
    }

    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'false');
    }

    if (submenu) {
      this.resetNestedMenus(submenu);
    }

    var focusTarget = options.returnFocus || trigger || toggleButton;
    var self = this;
    var finalized = false;

    var finalizeClose = function () {
      if (finalized) {
        return;
      }
      finalized = true;

      if (submenu) {
        submenu.classList.remove('mobile-subdrawer__list');

        var previousState = submenu.getAttribute('data-mobile-subdrawer-prev-state');
        if (previousState) {
          submenu.setAttribute('data-animation-state', previousState);
        } else {
          submenu.removeAttribute('data-animation-state');
        }
        submenu.removeAttribute('data-mobile-subdrawer-prev-state');

        var previousAnimation = submenu.getAttribute('data-mobile-subdrawer-prev-animation');
        if (previousAnimation) {
          submenu.setAttribute('data-animation', previousAnimation);
        } else {
          submenu.removeAttribute('data-animation');
        }
        submenu.removeAttribute('data-mobile-subdrawer-prev-animation');

        var inlineStyle = submenu.getAttribute('data-mobile-subdrawer-inline-style');
        if (inlineStyle) {
          submenu.setAttribute('style', inlineStyle);
        } else {
          submenu.removeAttribute('style');
        }
        submenu.removeAttribute('data-mobile-subdrawer-inline-style');

        var wasHidden = submenu.getAttribute('data-mobile-subdrawer-was-hidden');
        if (wasHidden === 'true') {
          submenu.setAttribute('hidden', '');
        } else {
          submenu.removeAttribute('hidden');
        }
        submenu.removeAttribute('data-mobile-subdrawer-was-hidden');

        self.resetPreparedItems(submenu);

        if (placeholder && placeholder.parentNode) {
          placeholder.parentNode.insertBefore(submenu, placeholder);
        }
      }

      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.removeChild(placeholder);
      }

      if (link) {
        link.classList.remove('navmenu-link-parent-active');
        link.removeAttribute('data-mobile-subdrawer-applied');
      }

      if (self.panel && typeof self.panelScrollTop === 'number') {
        self.panel.scrollTop = self.panelScrollTop;
      }

      self.clearItemAnimationTimer();

      var shouldResetDrawerState = !self.active || self.active === context;

      if (shouldResetDrawerState && self.subDrawerContent) {
        self.subDrawerContent.innerHTML = '';
      }

      if (shouldResetDrawerState && self.subDrawer && self.subDrawer.classList) {
        self.subDrawer.classList.remove('mobile-subdrawer--items-active');
        self.subDrawer.classList.remove('mobile-subdrawer--items-enter');
        self.subDrawer.classList.remove('mobile-subdrawer--items-exit');
      }

      if (self.active === context) {
        self.active = null;

        self.hideCta();

        if (!options.skipFocus && focusTarget && typeof focusTarget.focus === 'function') {
          try {
            focusTarget.focus();
          } catch (error) {
            // best effort focus
          }
        }
      }
    };

    if (forceInstant) {
      finalizeClose();
    } else {
      this.animateSubmenuItems('exit', finalizeClose);
    }
    this.setRootState(false);
  };

  MobileNavSubDrawer.prototype.resetNestedMenus = function (submenu) {
    if (!submenu || typeof submenu.querySelectorAll !== 'function') {
      return;
    }

    // Close any nested accordions so the submenu returns in a clean state
    var openButtons = submenu.querySelectorAll('[data-navmenu-trigger][aria-expanded="true"]');
    Array.prototype.forEach.call(openButtons, function (button) {
      dispatchClick(button);
    });

    // Ensure toggles report a closed state when the drawer is re-opened
    var triggerButtons = submenu.querySelectorAll('[data-navmenu-trigger]');
    Array.prototype.forEach.call(triggerButtons, function (button) {
      button.setAttribute('aria-expanded', 'false');
    });

    var activeLinks = submenu.querySelectorAll('.navmenu-link-parent-active');
    Array.prototype.forEach.call(activeLinks, function (link) {
      link.classList.remove('navmenu-link-parent-active');
      link.setAttribute('aria-expanded', 'false');
    });

    var expandedParentLinks = submenu.querySelectorAll('.navmenu-link-parent[aria-expanded="true"]');
    Array.prototype.forEach.call(expandedParentLinks, function (link) {
      link.setAttribute('aria-expanded', 'false');
    });

    var nestedSubmenus = submenu.querySelectorAll('[data-navmenu-submenu]');
    Array.prototype.forEach.call(nestedSubmenus, function (child) {
      if (child === submenu) {
        return;
      }

      child.setAttribute('data-accordion-state', 'closed');
      child.removeAttribute('data-accordion-animation');
      child.setAttribute('hidden', '');
      if (child.style) {
        child.style.removeProperty('--menu-open-height');
        child.style.removeProperty('height');
      }
    });
  };

  MobileNavSubDrawer.prototype.updateTitle = function (link) {
    if (!this.subDrawerTitle) {
      return;
    }

    var titleText = '';
    var labelNode = link && typeof link.querySelector === 'function' ? link.querySelector('[data-mobile-nav-link-label]') : null;

    if (labelNode && labelNode.textContent) {
      titleText = labelNode.textContent.trim();
    } else if (link && link.textContent) {
      titleText = link.textContent.trim();
    }

    this.subDrawerTitle.textContent = titleText || this.defaultTitle;
  };

  MobileNavSubDrawer.prototype.extractLinkLabel = function (link) {
    if (!link || typeof link.querySelector !== 'function') {
      return '';
    }

    var labelNode = link.querySelector('[data-mobile-nav-link-label]');
    if (labelNode && labelNode.textContent) {
      return labelNode.textContent.trim();
    }

    if (link.textContent) {
      return link.textContent.trim();
    }

    return '';
  };

  MobileNavSubDrawer.prototype.hideCta = function () {
    if (!this.subDrawerCtaWrapper) {
      return;
    }

    if (this.subDrawerCtaLink) {
      try {
        this.subDrawerCtaLink.setAttribute('href', '#');
      } catch (error) {
        // ignore
      }

      if (this.subDrawerCtaBaseText) {
        this.subDrawerCtaLink.textContent = this.subDrawerCtaBaseText;
      }
    }

    this.subDrawerCtaWrapper.setAttribute('hidden', '');
    this.subDrawerCtaWrapper.removeAttribute('data-mobile-subdrawer-cta-active');

    if (this.subDrawer && this.subDrawer.classList) {
      this.subDrawer.classList.remove('mobile-subdrawer--cta-active');
    }
  };

  MobileNavSubDrawer.prototype.updateCta = function (link) {
    if (!this.subDrawerCtaWrapper || !this.subDrawerCtaLink) {
      return;
    }

    var shouldShow = !!(link && link.getAttribute('data-mobile-subdrawer-view-all') === 'true');
    var url = shouldShow ? link.getAttribute('data-mobile-subdrawer-view-all-url') : '';

    if (!shouldShow || !url) {
      this.hideCta();
      return;
    }

  var linkTitle = this.extractLinkLabel(link);
  var menuTitle = linkTitle || (this.subDrawerTitle ? this.subDrawerTitle.textContent.trim() : '');
    var template = this.subDrawerCtaTemplate || '';
    var label = '';

    if (template && template.indexOf('[[menu]]') !== -1) {
      label = template.replace(/\[\[menu\]\]/g, menuTitle);
    } else if (template) {
      label = template;
    } else if (this.subDrawerCtaBaseText) {
      label = menuTitle ? this.subDrawerCtaBaseText + ' ' + menuTitle : this.subDrawerCtaBaseText;
    } else {
      label = menuTitle;
    }

    this.subDrawerCtaLink.textContent = label;

    try {
      this.subDrawerCtaLink.setAttribute('href', url);
    } catch (error) {
      // ignore
    }

    this.subDrawerCtaWrapper.removeAttribute('hidden');
    this.subDrawerCtaWrapper.setAttribute('data-mobile-subdrawer-cta-active', 'true');

    if (this.subDrawer && this.subDrawer.classList) {
      this.subDrawer.classList.add('mobile-subdrawer--cta-active');
    }
  };

  MobileNavSubDrawer.prototype.setRootState = function (isOpen) {
    if (!this.subDrawer) {
      return;
    }

    this.clearAnimationTimer();

    if (isOpen) {
      this.pendingRootReset = false;
      this.pendingRootClassRemoval = false;

      this.hideRootContent();

      this.subDrawer.removeAttribute('data-animation');
      this.subDrawer.classList.add('mobile-subdrawer--animating');
      this.subDrawer.classList.remove('mobile-subdrawer--active');
      this.subDrawer.setAttribute('aria-hidden', 'false');

      if (this.root && this.root.classList) {
        this.root.classList.add('mobile-nav--subdrawer-open');
      }
      toggleBodySubdrawerClass(true);

      this.triggerAnimation();

      this.startAnimationTimer(OPEN_TRANSITION_DURATION);
      return;
    } else {
      this.subDrawer.setAttribute('aria-hidden', 'true');
      this.subDrawer.classList.remove('mobile-subdrawer--active');

      var wasOpen = this.subDrawer.getAttribute('data-animation-state') === 'open';

      if (wasOpen) {
        this.pendingRootReset = true;
        this.pendingRootClassRemoval = true;

        if (this.root && this.root.classList) {
          this.root.classList.add('mobile-nav--subdrawer-closing');
        }

        this.subDrawer.classList.add('mobile-subdrawer--animating');
        this.forceLayout(this.subDrawer);
        this.subDrawer.setAttribute('data-animation', 'open=>closed');
        this.subDrawer.setAttribute('data-animation-state', 'closed');

        this.startAnimationTimer(CLOSE_TRANSITION_DURATION);
      } else {
        this.pendingRootReset = false;
        this.pendingRootClassRemoval = false;

        this.subDrawer.classList.remove('mobile-subdrawer--animating');
        this.subDrawer.removeAttribute('data-animation');
        this.subDrawer.setAttribute('data-animation-state', 'closed');

        this.restoreRootContent();

        if (this.root && this.root.classList) {
          this.root.classList.remove('mobile-nav--subdrawer-open');
        }
        toggleBodySubdrawerClass(false);
      }
    }
  };

  MobileNavSubDrawer.prototype.clearAnimationTimer = function () {
    if (!this.animationFallbackTimer) {
      return;
    }

    if (typeof window !== 'undefined' && typeof window.clearTimeout === 'function') {
      window.clearTimeout(this.animationFallbackTimer);
    } else {
      clearTimeout(this.animationFallbackTimer);
    }
    this.animationFallbackTimer = null;
  };

  MobileNavSubDrawer.prototype.startAnimationTimer = function (duration) {
    this.clearAnimationTimer();

    if (typeof window === 'undefined') {
      return;
    }

    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      try {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          duration = 0;
        }
      } catch (error) {
        // No-op; proceed with provided duration
      }
    }

    if (!duration || duration <= 0) {
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function () {
          this.onAnimationComplete();
        }.bind(this));
      } else {
        this.onAnimationComplete();
      }

      return;
    }

    this.animationFallbackTimer = window.setTimeout(function () {
      this.onAnimationComplete();
    }.bind(this), duration + ANIMATION_FALLBACK_BUFFER);
  };

  MobileNavSubDrawer.prototype.onTransitionEnd = function (event) {
    if (!this.subDrawer || !event) {
      return;
    }

    if (event.target !== this.subDrawer || event.propertyName !== 'transform') {
      return;
    }

    this.onAnimationComplete();
  };

  MobileNavSubDrawer.prototype.onAnimationComplete = function () {
    this.clearAnimationTimer();

    if (!this.subDrawer) {
      return;
    }

    this.subDrawer.classList.remove('mobile-subdrawer--animating');
    this.subDrawer.removeAttribute('data-animation');

    var state = this.subDrawer.getAttribute('data-animation-state');

    if (state === 'open') {
      this.pendingRootReset = false;
      this.pendingRootClassRemoval = false;
      this.subDrawer.setAttribute('aria-hidden', 'false');
      return;
    }

    if (this.pendingRootReset) {
      this.restoreRootContent();
      this.pendingRootReset = false;
    }

    if (this.pendingRootClassRemoval && this.root && this.root.classList) {
      this.root.classList.remove('mobile-nav--subdrawer-open');
      this.root.classList.remove('mobile-nav--subdrawer-closing');
      this.pendingRootClassRemoval = false;
      toggleBodySubdrawerClass(false);
    }
  };

  MobileNavSubDrawer.prototype.destroy = function () {
    this.closeSubDrawer({ skipFocus: true, forceInstant: true });
    this.clearAnimationTimer();
    this.onAnimationComplete();
    this.clearItemAnimationTimer();

    if (this.subDrawer && this.subDrawer.classList) {
      this.subDrawer.classList.remove('mobile-subdrawer--items-active');
      this.subDrawer.classList.remove('mobile-subdrawer--items-enter');
      this.subDrawer.classList.remove('mobile-subdrawer--items-exit');
    }

    this.hideCta();

    this.pendingRootReset = false;
    this.pendingRootClassRemoval = false;
    this.restoreRootContent();

    while (this.cleanups.length) {
      var cleanup = this.cleanups.pop();
      if (typeof cleanup === 'function') {
        cleanup();
      }
    }

    if (this.root && this.root.classList) {
      this.root.classList.remove('mobile-nav--subdrawer-open');
      this.root.classList.remove('mobile-nav--subdrawer-enabled');
    }
    toggleBodySubdrawerClass(false);
  };

  document.addEventListener('DOMContentLoaded', function () {
    initAllDrawers();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllDrawers(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyInScope(event.target);
  });
})();
